"use client";

import React from "react";
import { ArrowRight, MapPin } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
interface CityLocation {
  name: string;
  region: string;
  to: string;
}
const ukCities: CityLocation[] = [{
  name: "Local SEO Consultant Bedford",
  region: "Bedfordshire & East of England",
  to: "/local-seo-consultant-bedford"
}, {
  name: "Local SEO Consultant York",
  region: "Yorkshire & The Humber",
  to: "/local-seo-consultant-york"
}, {
  name: "Local SEO Consultant Wigan",
  region: "Greater Manchester & North West",
  to: "/local-seo-consultant-wigan"
}, {
  name: "Local SEO Consultant Derby",
  region: "Derbyshire & East Midlands",
  to: "/local-seo-consultant-derby"
}, {
  name: "Local SEO Consultant Milton Keynes",
  region: "Buckinghamshire & South East",
  to: "/local-seo-consultant-milton-keynes"
}, {
  name: "Local SEO Consultant Norwich",
  region: "Norfolk & East Anglia",
  to: "/local-seo-consultant-norwich"
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.21, 0.47, 0.32, 0.98]
    }
  }
};
export default function LocalSeoSupport() {
  return <section id="localseosupportuk" data-nav="light" className="relative bg-background text-foreground py-20 md:py-28 border-t border-border overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-14 md:mb-18">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-5">
            Local SEO Support Across the UK
          </h2>
          <p className="font-default text-muted-foreground text-base sm:text-lg leading-relaxed">
            Alongside this nationwide Local SEO hub, I provide dedicated regional strategies and tailored landing points for location-specific search queries across towns and commercial centres throughout the UK.
          </p>
        </div>

        {/* City Cards Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-60px"
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-14">
          {ukCities.map((city, index) => <motion.div key={city.name} variants={itemVariants} data-index={index}>
              <Link to={city.to} className="group block h-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-xl">
                <Card className="h-full border border-border bg-card hover:bg-card/90 transition-all duration-200 hover:shadow-md hover:border-primary/40 group-hover:-translate-y-1">
                  <CardContent className="p-6 flex items-start justify-between gap-4">
                    <div className="flex items-start gap-4">
                      <div className="p-2.5 rounded-lg bg-secondary text-primary shrink-0 transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                        <MapPin className="size-5" />
                      </div>
                      <div>
                        <h3 className="font-serif font-semibold text-foreground text-lg leading-snug group-hover:text-primary transition-colors">
                          {city.name}
                        </h3>
                        <p className="text-xs font-default text-muted-foreground mt-1">
                          {city.region}
                        </p>
                      </div>
                    </div>
                    <div className="text-muted-foreground shrink-0 mt-1 transition-all duration-200 group-hover:text-primary group-hover:translate-x-1">
                      <ArrowRight className="size-5" />
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </motion.div>)}
        </motion.div>

        {/* View All UK Locations Hub CTA */}
        <div className="text-center pt-2">
          <Button asChild size="lg" variant="outline" className="border-border hover:border-primary text-foreground hover:text-primary-foreground hover:bg-primary font-medium px-8 transition-all shadow-xs">
            <Link to="#">
              <span>View All UK Locations</span>
              <ArrowRight className="size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}